const mainField = "id";

const dataFieldConfig = [
  {
    id: "display_pos",
    field: "display_pos",
    align: "center",
    disablePadding: false,
    label: "次序",
  },
  {
    id: "grp_code",
    field: "grp_code",
    align: "center",
    disablePadding: false,
    label: "社代碼",
  },
  {
    id: "name_zh",
    field: "name_zh",
    align: "center",
    disablePadding: false,
    label: "中文名稱",
  },
  {
    id: "name_en",
    field: "name_en",
    align: "center",
    disablePadding: false,
    label: "English Name",
  },
];

const fetchDataConfig = {
  url: "/orgGrp/query",
  fixedFilter: [{ field: "org_id", value: null, op: "eq" }],
  defaultSort: "display_pos.asc,id.asc",
};

const tableActionConfig = [
  {
    type: "link",
    label: "Edit",
    icon: "edit",
    url: "/organization/$org_id/grp/detail/$id",
  },
  {
    type: "confirmDialog",
    label: "Delete",
    icon: "delete",
    url: "/orgGrp/delete/$id",
    dialogConfig: {
      title: "確定要刪除嗎？",
      icon: "warning",
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonAriaLabel: "確定",
      cancelButtonAriaLabel: "取消",
      cancelButtonColor: "#a7a7a7",
      successMsg: "刪除成功",
      failMsg: "刪除失敗",
    },
  },
];

const filterConfig = [
  { type: "text", label: "按名稱或社代碼搜索", field: "name_zh,name_en,grp_code" },
];

const TableConfig = {
  mainField,
  dataFieldConfig,
  fetchDataConfig,
  tableActionConfig,
  filterConfig,
};

export default TableConfig;
